import { render } from "./Result.vue?vue&type=template&id=a346c226"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"

import "./Result.vue?vue&type=style&index=0&id=a346c226&lang=less"
script.render = render

export default script